
class HighlightsFilter extends HTMLElement {
  ACTIVE_CLASS = 'highlights__item--active';

  connectedCallback() {
    this.clickHandler = (e) => this.handleClick(e);
    this.popstateHandler = () => this.syncActiveState();
    this.dispatching = false;

    this.addEventListener('click', this.clickHandler);
    window.addEventListener('popstate', this.popstateHandler);
    this.syncActiveState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
    window.removeEventListener('popstate', this.popstateHandler);
  }

  /**
   * Handle click.
   * @param {Event} e
   * @returns {void}
   */
  handleClick(e) {
    const link = e.target.closest('[data-filter-url]');
    if (!link) return;

    e.preventDefault();

    const targetUrl = link.getAttribute('data-filter-url');
    const item = link.closest('.highlights__item');
    const isActive = item && item.classList.contains(this.ACTIVE_CLASS);

    this.clearActive();
    this.dispatching = true;

    if (isActive) {
      // Re-clicking active highlight: reset to base collection path
      window.history.pushState(null, '', window.location.pathname);
    } else {
      if (item) item.classList.add(this.ACTIVE_CLASS);
      window.history.pushState(null, '', targetUrl);
    }

    // Trigger existing CollectionFiltersForm to fetch & replace product grid
    window.dispatchEvent(new PopStateEvent('popstate'));
    this.dispatching = false;
  }

  /**
   * Sync active state with current URL.
   * @returns {void}
   */
  syncActiveState() {
    if (this.dispatching) return;

    this.clearActive();

    const current = window.location.pathname + window.location.search;

    this.querySelectorAll('[data-filter-url]').forEach((link) => {
      const filterUrl = link.getAttribute('data-filter-url');
      const item = link.closest('.highlights__item');

      if (!item) return;

      // Resolve to absolute then compare pathname + search
      const resolved = new URL(filterUrl, window.location.origin);
      const resolvedHref = resolved.pathname + resolved.search;

      if (resolvedHref === current) {
        item.classList.add(this.ACTIVE_CLASS);
      }
    });
  }

  /**
   * Clear active state.
   * @returns {void}
   */
  clearActive() {
    this.querySelectorAll(`.${this.ACTIVE_CLASS}`).forEach((el) => {
      el.classList.remove(this.ACTIVE_CLASS);
    });
  }
}

if (!customElements.get('highlights-filter')) {
  customElements.define('highlights-filter', HighlightsFilter);
}
